import React from 'react';
import { withTheme } from 'glamorous';
import StandardPageTemplate from '../../common/components/Layout/StandardPageTemplate';
import FetchTiles from '../../common/components/FetchTiles';
import LandingView from '../../common/components/LandingView';
import LoadingView from '../../common/components/LoadingView';

class HomePage extends React.Component {
  render() {
    const { colors } = this.props.theme;
    return (
      <StandardPageTemplate defaultDocTitle="Engage | NFIB">
        <FetchTiles
          name="home"
          iconColorResolver={({ color }) => colors[color]}
        >
          {tiles => {
            if (!tiles || tiles.length === 0) {
              return <LoadingView />;
            }
            return <LandingView tiles={tiles} />;
          }}
        </FetchTiles>
      </StandardPageTemplate>
    );
  }
}

export default withTheme(HomePage);



// WEBPACK FOOTER //
// ./src/App/_root/HomePage.js